import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CONTRACT TRANSACTIONTYPES***//
export const getContractTransactionTypes = createAction(
  "GET_CONTRACT_TRANSACTION_TYPES",
  ({
    payload,
    params,
  }: SagaActionParams<Type.ContractTransactionTypeDto[]>) => ({
    payload,
    url: "/api/admin/contracttransactiontype" + (params ? params : ""),
  })
);
export const getContractTransactionTypeDetails = createAction(
  "GET_CONTRACT_TRANSACTION_TYPES_DETAILS",
  ({
    payload,
    id,
  }: SagaActionParams<Type.ContractTransactionTypeDetailDto>) => ({
    payload,
    url: "/api/admin/contracttransactiontype/" + id,
  })
);
export const createContractTransactionType = createAction(
  "CREATE_CONTRACT_TRANSACTION_TYPES",
  ({ payload, body }: SagaActionParams<Type.ContractTransactionTypeDto>) => ({
    payload,
    url: "/api/admin/contracttransactiontype",
    body,
  })
);
export const updateContractTransactionType = createAction(
  "UPDATE_CONTRACT_TRANSACTION_TYPES",
  ({
    payload,
    id,
    body,
  }: SagaActionParams<Type.ContractTransactionTypeDto>) => ({
    payload,
    url: "/api/admin/contracttransactiontype/" + id,
    body,
  })
);
export const deleteContractTransactionType = createAction(
  "DELETE_CONTRACT_TRANSACTION_TYPES",
  ({ payload, id }: SagaActionParams<Type.ContractTransactionTypeDto>) => ({
    payload,
    url: "/api/admin/contracttransactiontype/" + id,
  })
);

const contractTransactionTypeSaga = [
  /****************CONTRACT TRANSACTION TYPES****************/
  takeLatest<any>(
    getContractTransactionTypes.toString(),
    (payload: SagaGenericParams<Type.ContractTransactionTypeDto[]>) =>
      getSaga<Type.ContractTransactionTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getContractTransactionTypeDetails.toString(),
    (payload: SagaGenericParams<Type.ContractTransactionTypeDetailDto>) =>
      getSaga<Type.ContractTransactionTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createContractTransactionType.toString(),
    (payload: SagaGenericParams<Type.ContractTransactionTypeDetailDto>) =>
      postSaga<Type.ContractTransactionTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    updateContractTransactionType.toString(),
    (payload: SagaGenericParams<Type.ContractTransactionTypeDetailDto>) =>
      putSaga<Type.ContractTransactionTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteContractTransactionType.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ContractTransactionTypeDetailDto>(payload)
  ),
];

export default contractTransactionTypeSaga;
